module.exports = __webpack_public_path__ + "img/gmail_c.d0915bc3.svg";